/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getShipmentBasic } from "api/services/shipment";
import { shipmentQueryKeys } from "./shipmentQueryKeys";

export const useGetShipmentBasic = (shipmentId: string, options: UseQueryOptions): any =>
  useQuery({
    queryKey: shipmentQueryKeys.shipmentBasicDetails(shipmentId),
    queryFn: () => getShipmentBasic(shipmentId).then((res) => res.data),
    ...options,
    enabled: options.enabled ?? true,
  });
